import { utils, forms } from '@costar/theme-ui';

var baseRadio = forms.radio;
var radio = {
  "default": function _default(theme, props) {
    var _default2;
    var baseTheme = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (_default2 = baseRadio === null || baseRadio === void 0 ? void 0 : baseRadio['default'](theme, props)) !== null && _default2 !== void 0 ? _default2 : utils.EMPTY_OBJECT;
    return utils.omit(baseTheme, ['&:hover:not([disabled])']);
  }
};

export default radio;
//# sourceMappingURL=radio.esm.js.map
